export class Validator {
  public static readonly phoneNumberRegExp = new RegExp(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/);
  public static readonly textAreaLengthLimit = 1000;
  public static readonly minLengthName: number = 2;
  public static readonly maxLengthName: number = 50;
  public static readonly translateMainCode: string = 'FORM_VALIDATE_ERRORS.';
}